import { styled } from 'styled-components';

export const LoadModalContainer = styled.div`
  width: 45vw;
  height: 40vh;
`;
LoadModalContainer.displayName = 'LoadModalContainer';

export const LoadModalTableWrapper = styled.div`
  table {
    thead {
      tr {
        th:first-child {
          width: 100%;
        }
      }
    }
  }
`;
LoadModalTableWrapper.displayName = 'LoadModalTableWrapper';

export const LoadModalSearchWrapper = styled.div`
  > div {
    width: 50% !important;

    input {
      width: 100%;
    }
  }
`;
LoadModalSearchWrapper.displayName = 'LoadModalSearchWrapper';

export const LoadModalHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.small};
`;
LoadModalHeader.displayName = 'LoadModalHeader';

export const LoadModalStatusWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  vertical-align: bottom;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};

  svg {
    color: ${({ theme }) => theme.colours.messaging.info.main};
  }
`;

LoadModalStatusWrapper.displayName = 'LoadModalStatsWrapper';
